<div class="min-h-screen bg-white dark:bg-black rounded-lg p-4">
  <div class="mb-4">
    <p-breadcrumb
      [model]="displayBreadcrumbs()"
      styleClass="rounded-lg border border-gray-200 dark:border-gray-800"
    >
      <ng-template pTemplate="separator">
        <i class="pi pi-chevron-right text-primary-400 text-sm mx-2"></i>
      </ng-template>
      <ng-template let-item pTemplate="item">
        @if (item.routerLink && !item.disabled) {
          <a
            [routerLink]="item.routerLink"
            class="flex items-center text-primary-600 hover:text-primary-800 dark:hover:text-primary-500 dark:text-primary-300 transition-colors duration-200"
          >
            @if (item.icon) {
              <i [class]="item.icon + ' mr-2'"></i>
            }
            <span>{{ item.label | translate }}</span>
          </a>
        } @else {
          <span class="flex items-center text-primary-600 dark:text-primary-300">
            @if (item.icon) {
              <i [class]="item.icon + ' mr-2'"></i>
            }
            <span class="font-medium">{{ item.label | translate }}</span>
          </span>
        }
      </ng-template>
    </p-breadcrumb>
  </div>

  <div class="flex items-center flex-col sm:flex-row mb-8">
    <div class="flex items-center justify-center bg-primary-100 rounded-full h-16 w-16 mr-2">
      <i class="pi pi-truck text-primary-500 !text-3xl"></i>
    </div>
    <h2 class="text-3xl font-bold text-gray-900 dark:text-white text-center">
      {{ 'providerModule.title' | translate }}
    </h2>
  </div>

  <!-- Filtros -->
  <div
    class="mb-8 rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900"
  >
    <div class="flex flex-col gap-3 p-4 sm:flex-row sm:items-start lg:items-center">
      <div class="relative flex-1">
        <i
          class="pi pi-search absolute left-4 top-1/2 -translate-y-1/2 text-sm text-gray-400 dark:text-gray-500"
        ></i>
        <input
          (input)="onSearchInput()"
          [(ngModel)]="searchTerm"
          [placeholder]="'providerModule.searchingProviders' | translate"
          class="h-9 w-full rounded-lg border border-gray-200 bg-[oklch(0.98_0.003_240)] !pl-12 pr-9 text-sm text-gray-700 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-400"
          pInputText
          type="text"
        />
        @if (searchTerm) {
          <button
            (click)="onSearchClear()"
            class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 transition-colors hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
            type="button"
          >
            <i class="pi pi-times text-sm"></i>
          </button>
        }
      </div>

      <div
        class="grid w-full grid-cols-1 gap-2 sm:w-auto sm:grid-cols-[auto_auto] lg:grid-cols-[auto_auto_auto_auto] lg:items-center"
      >
        <i
          class="pi pi-sliders-h justify-self-start self-center text-sm text-gray-400 dark:text-gray-500"
        ></i>

        <p-select
          (onChange)="onStatusFilterChange($event.value)"
          [(ngModel)]="selectedStatus"
          class="w-full sm:min-w-[180px] lg:min-w-[140px]"
          [options]="statusOptions"
          [styleClass]="
            'h-9 w-full text-sm ' +
            (selectedStatus !== 'all' ? 'border-primary-300 bg-primary-50 text-primary-700' : '')
          "
          optionLabel="label"
          optionValue="value"
          placeholder="Estado"
        >
          <ng-template let-option pTemplate="item">
            <div class="flex items-center gap-2 text-sm">
              <i [class]="option.icon"></i>
              <span>{{ option.label }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="selectedItem">
            @if (selectedStatus) {
              <div class="flex items-center gap-2 text-sm">
                <i [class]="getSelectedStatusIcon()"></i>
                <span>{{ getSelectedStatusLabel() }}</span>
              </div>
            }
          </ng-template>
        </p-select>

        <p-select
          (onChange)="onCoesStatusFilterChange($event.value)"
          [(ngModel)]="selectedCoesStatus"
          class="w-full sm:min-w-[180px] lg:min-w-[150px]"
          [options]="coesStatusOptions"
          [styleClass]="
            'h-9 w-full text-sm ' +
            (selectedCoesStatus ? 'border-primary-300 bg-primary-50 text-primary-700' : '')
          "
          optionLabel="label"
          optionValue="value"
          placeholder="Estado COES"
        >
          <ng-template let-option pTemplate="item">
            <div class="flex items-center gap-2 text-sm">
              <i [class]="option.icon"></i>
              <span>{{ option.label }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="selectedItem">
            <div class="flex items-center gap-2 text-sm">
              <i [class]="getCoesSelectedStatusIcon()"></i>
              <span>{{ getCoesSelectedStatusLabel() }}</span>
            </div>
          </ng-template>
        </p-select>

        @if (hasActiveFilters()) {
          <p-button
            (onClick)="clearFilters()"
            styleClass="w-full sm:w-auto"
            label="Limpiar"
            severity="secondary"
            text
          ></p-button>
        }
      </div>
    </div>

    @if (!hasActiveFilters()) {
      <div
        class="mx-4 mb-4 flex items-start gap-2.5 rounded-lg border border-primary-200 bg-primary-50 px-4 py-3 dark:border-primary-700/40 dark:bg-primary-900/20"
      >
        <i class="pi pi-info-circle mt-0.5 text-primary-600 dark:text-primary-300"></i>
        <p class="text-xs leading-relaxed text-primary-700 dark:text-primary-200">
          {{ getStatusDescription() }} {{ getCoesDescription() }}
        </p>
      </div>
    }
  </div>

  <!-- Tabla de proveedores -->
  @if (providers$ | async; as providers) {
    <lib-providers-table
      (delete)="confirmDelete($event)"
      (edit)="onEdit($event)"
      (pageChange)="onPageChange($event)"
      (toggleStatus)="onToggleStatus($event)"
      [first]="first"
      [loading]="(loading$ | async) ?? false"
      [providers]="providers"
      [rows]="rows"
      [totalRecords]="totalRecords"
    ></lib-providers-table>
  }

  <p-dialog
    (onHide)="hideEditModal()"
    [(visible)]="showEditDialog"
    [breakpoints]="{ '1024px': '95vw' }"
    [draggable]="false"
    [modal]="true"
    [resizable]="false"
    [showHeader]="false"
    [style]="{ width: '960px' }"
    styleClass="w-full"
  >
    <div class="flex max-h-[88vh] flex-col overflow-hidden bg-white dark:bg-transparent">
      <div
        class="sticky top-0 z-10 flex items-center justify-between border-b border-gray-200 bg-white px-6 py-5 dark:border-gray-700 dark:bg-transparent"
      >
        <div>
          <h2 class="text-xl font-bold text-gray-900 dark:text-gray-100">Editar Proveedor</h2>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            ID:
            <span class="font-mono font-semibold">#{{ currentEdit?.id }}</span>
          </p>
        </div>
        <p-button
          (onClick)="hideEditModal()"
          [ariaLabel]="'Cerrar modal'"
          icon="pi pi-times"
          rounded
          severity="secondary"
          text
        ></p-button>
      </div>

      <div class="flex-1 space-y-4 overflow-y-auto px-6 py-5">
        @if (isProviderUpdateBlocked()) {
          <div
            class="rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800 dark:border-amber-700/50 dark:bg-amber-900/20 dark:text-amber-200"
          >
            <div class="flex items-start gap-2">
              <i class="pi pi-exclamation-triangle mt-0.5"></i>
              <span>{{ getProviderUpdateBlockedMessage() }}</span>
            </div>
          </div>
        }

        <div
          class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-700 dark:bg-transparent"
        >
          <div
            class="flex items-center justify-between border-b border-gray-200 bg-gradient-to-r from-primary-50 to-white px-5 py-4 transition-colors duration-200 hover:from-primary-100 hover:to-primary-50 dark:border-gray-700 dark:from-transparent dark:to-transparent dark:hover:from-white/5 dark:hover:to-white/5"
          >
            <div class="flex items-center gap-3">
              <div
                class="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 dark:bg-gray-800"
              >
                <i class="pi pi-user text-primary-500"></i>
              </div>
              <div>
                <h3 class="text-sm font-semibold text-gray-900 dark:text-gray-100">
                  Información General
                </h3>
                <p class="text-xs text-gray-500 dark:text-gray-400">Datos base del proveedor</p>
              </div>
            </div>
            <p-button
              (onClick)="toggleGeneralSection()"
              [disabled]="isProviderUpdateBlocked()"
              [icon]="editableSection() === 'general' ? 'pi pi-times' : 'pi pi-pencil'"
              [label]="editableSection() === 'general' ? 'Cancelar edición' : 'Editar'"
              outlined
              severity="secondary"
              size="small"
            ></p-button>
          </div>

          <div [formGroup]="editProviderForm" class="grid grid-cols-1 gap-4 p-5 md:grid-cols-2">
            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                País
              </p>
              <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ currentEdit?.country ?? 'N/A' }}
              </p>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                Provincia
              </p>
              <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ currentEdit?.city ?? 'N/A' }}
              </p>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                Comuna
              </p>
              <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ currentEdit?.comune ?? 'N/A' }}
              </p>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                Nombre
              </p>
              <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ editProviderForm.value.provider_name }}
              </p>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                Razón Social
              </p>
              <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ editProviderForm.value.business_name }}
              </p>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                RUC
              </p>
              <p class="mt-1 font-mono text-sm font-semibold text-gray-900 dark:text-gray-100">
                {{ editProviderForm.value.RUC }}
              </p>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                Correo
              </p>
              <p class="mt-1 break-all text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ editProviderForm.value.email }}
              </p>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <label
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
                for="phone_edit"
              >
                Teléfono
              </label>
              @if (editableSection() === 'general') {
                <input
                  class="mt-2 w-full"
                  formControlName="phone"
                  id="phone_edit"
                  pInputText
                  placeholder="Ingresa teléfono"
                />
              } @else {
                <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                  {{ editProviderForm.value.phone }}
                </p>
              }
            </div>

            @if (currentEdit?.coes !== 'COES') {
              <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent" formGroupName="user_data">
                <label
                  class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
                  for="password_edit"
                >
                  Contraseña
                </label>

                @if (editableSection() === 'general') {
                  <input
                    [feedback]="false"
                    class="mt-2 w-full"
                    formControlName="password"
                    id="password_edit"
                    pPassword
                    placeholder="Ingresa nueva contraseña"
                    toggleMask="true"
                  />
                } @else {
                  <p class="mt-1 text-sm italic text-gray-500 dark:text-gray-400">
                    ******** (oculta)
                  </p>
                }

                @if (
                  editableSection() === 'general' &&
                  editProviderForm.get('user_data.password')?.errors &&
                  editProviderForm.get('user_data.password')?.value
                ) {
                  <div
                    @fadeInOut
                    class="mt-3 rounded-md border border-primary-200 bg-primary-50 p-3 text-xs text-primary-700 dark:border-gray-700 dark:bg-transparent dark:text-gray-200"
                  >
                    <ul class="list-inside list-disc space-y-0.5">
                      @if (editProviderForm.get('user_data.password')?.errors?.['uppercase']) {
                        <li>Debe contener al menos una letra mayúscula</li>
                      }
                      @if (editProviderForm.get('user_data.password')?.errors?.['lowercase']) {
                        <li>Debe contener al menos una letra minúscula</li>
                      }
                      @if (editProviderForm.get('user_data.password')?.errors?.['characters']) {
                        <li>Debe tener al menos 10 caracteres</li>
                      }
                      @if (editProviderForm.get('user_data.password')?.errors?.['special']) {
                        <li>Debe contener al menos un carácter especial</li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <label
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
                for="edit-role"
              >
                Rol
              </label>
              <p-select
                [appendTo]="'body'"
                [loading]="loadingRoles"
                [options]="roles"
                class="mt-2 w-full"
                formControlName="role"
                id="edit-role"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecciona un rol"
              ></p-select>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent md:col-span-2">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                Dirección
              </p>
              <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ editProviderForm.value.address }}
              </p>
            </div>
          </div>
        </div>

        <p-panel
          [collapsed]="true"
          [toggleable]="true"
          header="Información Bancaria"
          styleClass="bank-panel-hover"
        >
          <div class="grid grid-cols-1 gap-4 p-1 md:grid-cols-2">
            <div class="rounded-lg bg-amber-50 p-3 dark:bg-amber-900/20 md:col-span-2">
              <div class="flex items-start gap-2 text-amber-800 dark:text-amber-200">
                <i class="pi pi-info-circle mt-0.5"></i>
                <p class="text-xs">Esta sección es de solo lectura.</p>
              </div>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                Banco
              </p>
              <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ currentEdit?.bank_accounts?.[0]?.bank ?? 'N/A' }}
              </p>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                Número de Cuenta
              </p>
              <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ currentEdit?.bank_accounts?.[0]?.account_number ?? 'N/A' }}
              </p>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                Tipo de Cuenta
              </p>
              <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ currentEdit?.bank_accounts?.[0]?.account_type ?? 'N/A' }}
              </p>
            </div>

            <div class="rounded-lg bg-gray-50 p-3 dark:bg-transparent">
              <p
                class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                Moneda
              </p>
              <p class="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ currentEdit?.bank_accounts?.[0]?.currency ?? 'N/A' }}
              </p>
            </div>
          </div>
        </p-panel>
      </div>

      <div
        class="sticky bottom-0 z-10 flex justify-end gap-2 border-t border-gray-200 bg-white px-6 py-4 dark:border-gray-700 dark:bg-transparent"
      >
        <p-button
          (onClick)="hideEditModal()"
          label="Cancelar"
          outlined
          severity="secondary"
        ></p-button>
        <p-button
          (onClick)="submitEditForm()"
          [disabled]="editProviderForm.invalid || isProviderUpdateBlocked()"
          label="Guardar cambios"
        ></p-button>
      </div>
    </div>
  </p-dialog>
</div>
